import React from 'react';
export default class CommonNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render(){
        const _this = this;
        return (
            <div className="common-nav">
                <div className="imageBtnBack" onClick={ _this.goBack.bind(_this) }>
                    <img src={ require("../../assets/images/calendar_back.png") }/>
                </div>
            </div>     
        );
    }
    /**
     * 返回上一级页面
     * */ 
    goBack (){
        const _this = this;
        _this.props.history.goBack();
    }
    
}


